import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, TextField, Typography } from '@mui/material';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { deletePlaylist } from 'src/redux/actions/Playlist';

export default function ConfirmPlaylistDelete({playlistId, open, handleClose}) {
    const dispatch = useDispatch()

    const [deleteInputValue, setDeleteInputValue] = useState('')

    const redirectToScreens = () => {
        window.location.replace(`/screen?playlistId=${playlistId}`)
    }

    const handlePlaylistDelete = () => {
        dispatch(deletePlaylist([playlistId]));
        handleClose()
    }

  return (
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle id="alert-dialog-title">
            Some screens display this playlist
        </DialogTitle>
        <DialogContent>
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            mt: 1
          }}>
            <Button variant="contained" onClick={redirectToScreens}>Show screens</Button>
          </Box>
          <Box sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mt: 2,
            gap: '5px'
          }}>
            <Typography variant="body2">Type "delete" to remove playlist anyway</Typography>
            <TextField variant="outlined" hiddenLabel size="small" value={deleteInputValue} onInput={(e) => setDeleteInputValue(e.target.value)} />
            {deleteInputValue == 'delete' ? (
                <Button color="error" onClick={handlePlaylistDelete}>Delete</Button>
            ) : null}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
  );
}
